import { render, staticRenderFns } from "./registerHotel.vue?vue&type=template&id=aa55c6ce&scoped=true&"
import script from "./registerHotel.vue?vue&type=script&lang=ts&"
export * from "./registerHotel.vue?vue&type=script&lang=ts&"
import style0 from "./registerHotel.vue?vue&type=style&index=0&id=aa55c6ce&lang=scss&scoped=true&"
import style1 from "./registerHotel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55c6ce",
  null
  
)

export default component.exports